import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography, Box, Chip, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';

import ShowProformaInvoice from "components/product/components/price-calculation/ShowProformaInvoice";
import RemarkListPage from "components/remark/page/RemarkListPage";
import { setEditOrderStory } from "store/slice/AppSlice";
import { approveOrderAPI, referBackOrderAPI } from "api/OmsOrdermgmtWebServices";
import { updatePharmaorderObj } from "store/slice/PharmaSlice";
import {setOpenCommentDialogExternal} from "store/slice/AppSlice";
import { addRemarkObj } from "store/slice/PharmaSlice";


export default function OrderReviewMD() {
  const dispatch = useDispatch();
  const { remarkList } = useSelector((state) => state.pharmaslice.remarkDashboard);
  const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const [errMsg, setErrMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [apiInProgress, setApiInProgress] = useState(false);
  const [referBackDialogOpen, setReferBackDialogOpen] = useState(false);
  const [referBackComment, setReferBackComment] = useState('');
  const [referBackError, setReferBackError] = useState('');

  useEffect(() => {
  }, [remarkList]);

  const goToProductList = () => {
    dispatch(setEditOrderStory({ // Initialize the add order story state
      title: "Manage Product(s)",
      description: "Manage Product(s)",
      currentState: "ORDER_DASHBOARD",
    }));
  }
  const handleOrderSubmit = () => {
    setErrMsg('')
    setApiInProgress(true);

    approveOrderAPI({
      orderId: pharmaorderObj.id
    }, (response) => {
      dispatch(updatePharmaorderObj(response.pharmaorderInfo));
      setSuccessMsg("Order '" + response.pharmaorderInfo.id + "' is submitted for approval !!!");
    },
      (apiErrMsg) => {
        setApiInProgress(false);
        setErrMsg(apiErrMsg);
      }
    )
  }

  const handleReferBackOpen = () => {
    setReferBackDialogOpen(true);
    setReferBackError('');
    setErrMsg('');
  };

  const handleReferBackClose = () => {
    setReferBackDialogOpen(false);
    setReferBackComment('');
    setReferBackError('');
  };

  const handleReferBackSubmit = () => {
    if (!referBackComment.trim()) {
      setReferBackError('Please enter a comment.');
      return;
    }
    referBackOrderAPI({
      orderId: pharmaorderObj.id,
      comment: referBackComment.trim()
    }, (response) => {
      dispatch(updatePharmaorderObj(response.pharmaorderInfo));
      dispatch(addRemarkObj(response.remarkInfo));
      setSuccessMsg("Order '" + response.pharmaorderInfo.id + "' is Referred Back Successfully !!!");
      setReferBackDialogOpen(false);
      setReferBackComment('');
      setReferBackError('');
    },
      (apiErrMsg) => {
        setApiInProgress(false);
        setReferBackDialogOpen(false);
        setErrMsg(apiErrMsg);
      }
    )
    
  };

  return (
    <>
      <Grid
        container
        direction="row"
        sx={{ width: '100%', backgroundColor: 'secondary.lighter', height: '80vh' }}
      >
        <Grid item xs={12} lg={9}>
          <ShowProformaInvoice />
        </Grid>
        <Grid
          item
          xs={12}
          lg={3}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: 'white',
            padding: 1,
          }}
        >
          {/* Remarks Section */}
          <Box sx={{ flexShrink: 0, backgroundColor: 'secondary.lighter', p: 1, mb: 1 }}>
            <RemarkListPage maxHeight="50vh"/>
          </Box>
          {/* Spacer to push buttons to the bottom */}
          <Box sx={{ flexGrow: 1 }} />
          {/* Success Message */}
          {successMsg && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: 4,
                px: 2,
                mb: 2,
                backgroundColor: '#e8f5e9',
                borderRadius: 2,
                boxShadow: 2,
              }}
            >
              <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main', mb: 1 }} />
              <Typography variant="h6" color="success.main" sx={{ fontWeight: 600, mb: 1 }}>
                Success!
              </Typography>
              <Typography variant="body1" color="text.secondary" align="center">
                {successMsg}
              </Typography>
            </Box>
          )}
          {/* Button Container */}
          {!successMsg && (
            <Box sx={{ width: '100%', pt: 1, pb: 1 }}>
              <Divider sx={{ mb: 2 }} />
              {errMsg && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" color="error" align="center">
                    {errMsg}
                  </Typography>
                </Box>
              )}
              <Grid container direction="row" justifyContent="flex-end" spacing={2}>
                <Grid item>
                  <Button
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={handleReferBackOpen}
                    sx={{
                      color: 'error.main',
                      borderColor: 'error.main',
                      backgroundColor: 'error.lighter',
                      '&:hover': {
                        backgroundColor: 'error.light',
                        borderColor: 'error.dark',
                      },
                      fontWeight: 600,
                      textTransform: 'none'
                    }}
                  >
                    Refer Back
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    endIcon={<ArrowForwardIcon />}
                    onClick={handleOrderSubmit}
                    disabled={apiInProgress}
                  >
                    Submit for Approval1
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
      </Grid>

      {/* Refer Back Dialog */}
      <Dialog open={referBackDialogOpen} onClose={handleReferBackClose} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
          Refer Back Comments
          <Button
            onClick={handleReferBackClose}
            sx={{ minWidth: 0, color: 'grey.700' }}
            size="small"
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Enter your comments"
            type="text"
            fullWidth
            multiline
            minRows={3}
            value={referBackComment}
            onChange={e => {
              setReferBackComment(e.target.value);
              setReferBackError('');
            }}
            error={!!referBackError}
            helperText={referBackError}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReferBackClose} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleReferBackSubmit}
            color="error"
            variant="contained"
            disabled={!referBackComment.trim()}
          >
            Refer Back
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}